// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__3S_a9","checkbox":"Checkbox_checkbox__1FKvt","checkboxLabel":"Checkbox_checkboxLabel__1dCdM"};